/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FrictionShallowWaterDepthCorrectionEnum } from "./FrictionShallowWaterDepthCorrectionEnum";
import {
  FrictionShallowWaterDepthCorrectionEnumFromJSON,
  FrictionShallowWaterDepthCorrectionEnumFromJSONTyped,
  FrictionShallowWaterDepthCorrectionEnumToJSON,
  FrictionShallowWaterDepthCorrectionEnumToJSONTyped,
} from "./FrictionShallowWaterDepthCorrectionEnum";
import type { LimiterSlopeCrossectionalArea2dEnum } from "./LimiterSlopeCrossectionalArea2dEnum";
import {
  LimiterSlopeCrossectionalArea2dEnumFromJSON,
  LimiterSlopeCrossectionalArea2dEnumFromJSONTyped,
  LimiterSlopeCrossectionalArea2dEnumToJSON,
  LimiterSlopeCrossectionalArea2dEnumToJSONTyped,
} from "./LimiterSlopeCrossectionalArea2dEnum";
import type { UsePreconditionerCgEnum } from "./UsePreconditionerCgEnum";
import {
  UsePreconditionerCgEnumFromJSON,
  UsePreconditionerCgEnumFromJSONTyped,
  UsePreconditionerCgEnumToJSON,
  UsePreconditionerCgEnumToJSONTyped,
} from "./UsePreconditionerCgEnum";
import type { TimeIntegrationMethodEnum } from "./TimeIntegrationMethodEnum";
import {
  TimeIntegrationMethodEnumFromJSON,
  TimeIntegrationMethodEnumFromJSONTyped,
  TimeIntegrationMethodEnumToJSON,
  TimeIntegrationMethodEnumToJSONTyped,
} from "./TimeIntegrationMethodEnum";

/**
 *
 * @export
 * @interface NumericalSettings
 */
export interface NumericalSettings {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly simulationId?: number;
  /**
   *
   */
  pumpImplicitRatio: number;
  /**
   * Strictness of CFL (Courant–Friedrichs–Lewy) condition for 1D.
   */
  cflStrictnessFactor1d: number;
  /**
   * Strictness of CFL (Courant–Friedrichs–Lewy) condition for 2D.
   */
  cflStrictnessFactor2d: number;
  /**
   * Minimal convergence criterion for Newton's method, suitable default is 1.0e-5, due to numerical precision.
   */
  convergenceEps: number;
  /**
   * Convergence criterion of cg-method, suitable default is 1.0e-9, due to numerical precision.
   */
  convergenceCg: number;
  /**
   * Threshold value for upwind scheme based on flow velocity, suitable default is 1e-06.
   */
  flowDirectionThreshold: number;
  /**
   * In case the friction assumptions based on the dominant friction balance gives a structurally underestimation of the friction, you can switch this setting on.
   *  Options:
   * 0 = off
   * 1 = max between avg and divided channel based friction
   * 2 = always linearized
   * 3 = linearizes the depth based on a weighed averaged
   *
   *  If options 3 is used the maximum depth of a thin layer needs to be defined. Do not use in combination with interflow. Suitable default is 0 (OFF).
   *
   * * `0` - off
   * * `1` - max between avg and divided channel based friction
   * * `2` - always linearized
   * * `3` - linearizes the depth based on a weighed averaged
   */
  frictionShallowWaterDepthCorrection: FrictionShallowWaterDepthCorrectionEnum;
  /**
   * Suitable default is 1.0e-8
   */
  generalNumericalThreshold: number;
  /**
   * There are various methods to discretize the equations. At the moment only the first-order, semi-implicit method is supported and tested.
   * Options:
   * 0 = euler implicit
   *
   *
   * * `0` - euler implicit
   */
  timeIntegrationMethod?: TimeIntegrationMethodEnum;
  /**
   * The limiter on the water level gradient allows the model to deal with unrealistically steep gradients. Suitable default is 1.
   *
   * * `0` - off
   * * `1` - standard
   */
  limiterWaterlevelGradient1d: UsePreconditionerCgEnum;
  /**
   * The limiter on the water level gradient allows the model to deal with unrealistically steep gradients. Suitable default is 1.
   *
   * * `0` - off
   * * `1` - standard
   */
  limiterWaterlevelGradient2d: UsePreconditionerCgEnum;
  /**
   * This limiter starts working in case the depth based on the downstream water level is zero and may be useful in sloping areas.
   * Options:
   * 0 = off
   * 1 = higher order scheme (might be sensitive to instabilities)
   * 2 = cross-sections treated as upwind method volume/surface area
   * 3 = combination traditional method thin layer approach
   *  If option 3 is used the maximum depth of a thin layer needs to be defined. Do not use in combination with interflow.
   *
   * * `0` - off
   * * `1` - higher order scheme (might be sensitive to instabilities)
   * * `2` - cross-sections treated as upwind method volume/surface area
   * * `3` - combination traditional method thin layer approach
   */
  limiterSlopeCrossectionalArea2d: LimiterSlopeCrossectionalArea2dEnum;
  /**
   * This limiter starts working in case the depth based on the downstream water level is zero and may be useful in sloping areas. This limiter is mandatory if the limiter_slope_crossectional_area_2d setting is greater than 0. Do not use in combination with interflow. Suitable default is 0 (OFF)
   *  Options:
   * 0 = off
   * 1 = standard
   *
   *
   * * `0` - off
   * * `1` - standard
   */
  limiterSlopeFriction2d: UsePreconditionerCgEnum;
  /**
   * Maximum number of non-linear newton iterations in single time step. Suitable default is 20.
   */
  maxNonLinearNewtonIterations: number;
  /**
   * Values below are advised for different model types:
   * 700 for 1D flow
   * 7 for 1D and 2D flow
   * 5 for surface 2D flow only
   * 7 for surface and groundwater flow
   * 70 for 1D, 2D surface and groundwater flow or higher.
   * Play around with this value, can speed up your model significantly, especially in case of ground water flow. Suitable default is 0.
   */
  maxDegreeGaussSeidel: number;
  /**
   * To guarantee some initial friction only in flooded areas and for large time steps, it is wise to assume a minimum velocity for computing the friction. Suitable default is 0.01.
   */
  minFrictionVelocity: number;
  /**
   * Suitable default is 1.0e-8.
   */
  minSurfaceArea: number;
  /**
   * Use pre-conditioner for matrix solver. Increases simulation speed in most cases.
   * Options:
   * 0 = off
   * 1 = standard
   * . Suitable default is 1 (STANDARD).
   *
   * * `0` - off
   * * `1` - standard
   */
  usePreconditionerCg: UsePreconditionerCgEnum;
  /**
   * A conceptual vertical narrow slot providing a conceptual free surface condition for the flow when the water level is above the top of a closed conduit. Often used to guarantee stability. Not necessary in 3Di even for pressurized pipe flow. Note: Works only for circular profiles. Suitable default is 0.0. Unit: m2.
   */
  preissmannSlot: number;
  /**
   * Mandatory when using friction_shallow_water_depth_correction option 3 or limiter_slope_crossectional_area_2d option 3. Unit: m
   */
  limiterSlopeThinWaterLayer: number;
  /**
   * Number of conjugate gradient method iterations, before switching to another method. Suitable default is 20.
   */
  useOfCg: number;
  /**
   * Set to 'True' for 1D calculations with closed profiles to handle non-linearity in volume-water level relation. When set to 'False' it will be used if calculations become non-linear. For sewerage systems it is advised to set this setting to 'True'. Otherwise a suitable default is 'False'
   */
  useNestedNewton: boolean;
  /**
   * Water depth threshold for flow between 2D cells. Depth relative to lowest bathymetry pixel at the edge between two 2D cells. Suitable default is 0.000001.
   */
  floodingThreshold: number;
}

/**
 * Check if a given object implements the NumericalSettings interface.
 */
export function instanceOfNumericalSettings(value: object): value is NumericalSettings {
  if (
    (!("pumpImplicitRatio" in (value as Record<string, any>)) &&
      !("pump_implicit_ratio" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["pumpImplicitRatio"] === undefined &&
      (value as Record<string, any>)["pump_implicit_ratio"] === undefined)
  )
    return false;
  if (
    (!("cflStrictnessFactor1d" in (value as Record<string, any>)) &&
      !("cfl_strictness_factor_1d" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["cflStrictnessFactor1d"] === undefined &&
      (value as Record<string, any>)["cfl_strictness_factor_1d"] === undefined)
  )
    return false;
  if (
    (!("cflStrictnessFactor2d" in (value as Record<string, any>)) &&
      !("cfl_strictness_factor_2d" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["cflStrictnessFactor2d"] === undefined &&
      (value as Record<string, any>)["cfl_strictness_factor_2d"] === undefined)
  )
    return false;
  if (
    (!("convergenceEps" in (value as Record<string, any>)) &&
      !("convergence_eps" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["convergenceEps"] === undefined &&
      (value as Record<string, any>)["convergence_eps"] === undefined)
  )
    return false;
  if (
    (!("convergenceCg" in (value as Record<string, any>)) &&
      !("convergence_cg" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["convergenceCg"] === undefined &&
      (value as Record<string, any>)["convergence_cg"] === undefined)
  )
    return false;
  if (
    (!("flowDirectionThreshold" in (value as Record<string, any>)) &&
      !("flow_direction_threshold" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["flowDirectionThreshold"] === undefined &&
      (value as Record<string, any>)["flow_direction_threshold"] === undefined)
  )
    return false;
  if (
    (!("frictionShallowWaterDepthCorrection" in (value as Record<string, any>)) &&
      !("friction_shallow_water_depth_correction" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["frictionShallowWaterDepthCorrection"] === undefined &&
      (value as Record<string, any>)["friction_shallow_water_depth_correction"] === undefined)
  )
    return false;
  if (
    (!("generalNumericalThreshold" in (value as Record<string, any>)) &&
      !("general_numerical_threshold" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["generalNumericalThreshold"] === undefined &&
      (value as Record<string, any>)["general_numerical_threshold"] === undefined)
  )
    return false;
  if (
    (!("limiterWaterlevelGradient1d" in (value as Record<string, any>)) &&
      !("limiter_waterlevel_gradient_1d" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["limiterWaterlevelGradient1d"] === undefined &&
      (value as Record<string, any>)["limiter_waterlevel_gradient_1d"] === undefined)
  )
    return false;
  if (
    (!("limiterWaterlevelGradient2d" in (value as Record<string, any>)) &&
      !("limiter_waterlevel_gradient_2d" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["limiterWaterlevelGradient2d"] === undefined &&
      (value as Record<string, any>)["limiter_waterlevel_gradient_2d"] === undefined)
  )
    return false;
  if (
    (!("limiterSlopeCrossectionalArea2d" in (value as Record<string, any>)) &&
      !("limiter_slope_crossectional_area_2d" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["limiterSlopeCrossectionalArea2d"] === undefined &&
      (value as Record<string, any>)["limiter_slope_crossectional_area_2d"] === undefined)
  )
    return false;
  if (
    (!("limiterSlopeFriction2d" in (value as Record<string, any>)) &&
      !("limiter_slope_friction_2d" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["limiterSlopeFriction2d"] === undefined &&
      (value as Record<string, any>)["limiter_slope_friction_2d"] === undefined)
  )
    return false;
  if (
    (!("maxNonLinearNewtonIterations" in (value as Record<string, any>)) &&
      !("max_non_linear_newton_iterations" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["maxNonLinearNewtonIterations"] === undefined &&
      (value as Record<string, any>)["max_non_linear_newton_iterations"] === undefined)
  )
    return false;
  if (
    (!("maxDegreeGaussSeidel" in (value as Record<string, any>)) &&
      !("max_degree_gauss_seidel" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["maxDegreeGaussSeidel"] === undefined &&
      (value as Record<string, any>)["max_degree_gauss_seidel"] === undefined)
  )
    return false;
  if (
    (!("minFrictionVelocity" in (value as Record<string, any>)) &&
      !("min_friction_velocity" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["minFrictionVelocity"] === undefined &&
      (value as Record<string, any>)["min_friction_velocity"] === undefined)
  )
    return false;
  if (
    (!("minSurfaceArea" in (value as Record<string, any>)) &&
      !("min_surface_area" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["minSurfaceArea"] === undefined &&
      (value as Record<string, any>)["min_surface_area"] === undefined)
  )
    return false;
  if (
    (!("usePreconditionerCg" in (value as Record<string, any>)) &&
      !("use_preconditioner_cg" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["usePreconditionerCg"] === undefined &&
      (value as Record<string, any>)["use_preconditioner_cg"] === undefined)
  )
    return false;
  if (
    (!("preissmannSlot" in (value as Record<string, any>)) &&
      !("preissmann_slot" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["preissmannSlot"] === undefined &&
      (value as Record<string, any>)["preissmann_slot"] === undefined)
  )
    return false;
  if (
    (!("limiterSlopeThinWaterLayer" in (value as Record<string, any>)) &&
      !("limiter_slope_thin_water_layer" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["limiterSlopeThinWaterLayer"] === undefined &&
      (value as Record<string, any>)["limiter_slope_thin_water_layer"] === undefined)
  )
    return false;
  if (
    (!("useOfCg" in (value as Record<string, any>)) &&
      !("use_of_cg" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["useOfCg"] === undefined &&
      (value as Record<string, any>)["use_of_cg"] === undefined)
  )
    return false;
  if (
    (!("useNestedNewton" in (value as Record<string, any>)) &&
      !("use_nested_newton" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["useNestedNewton"] === undefined &&
      (value as Record<string, any>)["use_nested_newton"] === undefined)
  )
    return false;
  if (
    (!("floodingThreshold" in (value as Record<string, any>)) &&
      !("flooding_threshold" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["floodingThreshold"] === undefined &&
      (value as Record<string, any>)["flooding_threshold"] === undefined)
  )
    return false;
  return true;
}

export function NumericalSettingsFromJSON(json: any): NumericalSettings {
  return NumericalSettingsFromJSONTyped(json, false);
}

export function NumericalSettingsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NumericalSettings {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    simulationId: json["simulation_id"] == null ? undefined : json["simulation_id"],
    pumpImplicitRatio: json["pump_implicit_ratio"],
    cflStrictnessFactor1d: json["cfl_strictness_factor_1d"],
    cflStrictnessFactor2d: json["cfl_strictness_factor_2d"],
    convergenceEps: json["convergence_eps"],
    convergenceCg: json["convergence_cg"],
    flowDirectionThreshold: json["flow_direction_threshold"],
    frictionShallowWaterDepthCorrection: FrictionShallowWaterDepthCorrectionEnumFromJSON(
      json["friction_shallow_water_depth_correction"]
    ),
    generalNumericalThreshold: json["general_numerical_threshold"],
    timeIntegrationMethod:
      json["time_integration_method"] == null
        ? undefined
        : TimeIntegrationMethodEnumFromJSON(json["time_integration_method"]),
    limiterWaterlevelGradient1d: UsePreconditionerCgEnumFromJSON(
      json["limiter_waterlevel_gradient_1d"]
    ),
    limiterWaterlevelGradient2d: UsePreconditionerCgEnumFromJSON(
      json["limiter_waterlevel_gradient_2d"]
    ),
    limiterSlopeCrossectionalArea2d: LimiterSlopeCrossectionalArea2dEnumFromJSON(
      json["limiter_slope_crossectional_area_2d"]
    ),
    limiterSlopeFriction2d: UsePreconditionerCgEnumFromJSON(json["limiter_slope_friction_2d"]),
    maxNonLinearNewtonIterations: json["max_non_linear_newton_iterations"],
    maxDegreeGaussSeidel: json["max_degree_gauss_seidel"],
    minFrictionVelocity: json["min_friction_velocity"],
    minSurfaceArea: json["min_surface_area"],
    usePreconditionerCg: UsePreconditionerCgEnumFromJSON(json["use_preconditioner_cg"]),
    preissmannSlot: json["preissmann_slot"],
    limiterSlopeThinWaterLayer: json["limiter_slope_thin_water_layer"],
    useOfCg: json["use_of_cg"],
    useNestedNewton: json["use_nested_newton"],
    floodingThreshold: json["flooding_threshold"],
  };
}

export function NumericalSettingsToJSON(json: any): NumericalSettings {
  return NumericalSettingsToJSONTyped(json, false);
}

export function NumericalSettingsToJSONTyped(
  value?: Omit<NumericalSettings, "id" | "simulationId"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    pump_implicit_ratio: value["pumpImplicitRatio"],
    cfl_strictness_factor_1d: value["cflStrictnessFactor1d"],
    cfl_strictness_factor_2d: value["cflStrictnessFactor2d"],
    convergence_eps: value["convergenceEps"],
    convergence_cg: value["convergenceCg"],
    flow_direction_threshold: value["flowDirectionThreshold"],
    friction_shallow_water_depth_correction: FrictionShallowWaterDepthCorrectionEnumToJSON(
      value["frictionShallowWaterDepthCorrection"]
    ),
    general_numerical_threshold: value["generalNumericalThreshold"],
    time_integration_method: TimeIntegrationMethodEnumToJSON(value["timeIntegrationMethod"]),
    limiter_waterlevel_gradient_1d: UsePreconditionerCgEnumToJSON(
      value["limiterWaterlevelGradient1d"]
    ),
    limiter_waterlevel_gradient_2d: UsePreconditionerCgEnumToJSON(
      value["limiterWaterlevelGradient2d"]
    ),
    limiter_slope_crossectional_area_2d: LimiterSlopeCrossectionalArea2dEnumToJSON(
      value["limiterSlopeCrossectionalArea2d"]
    ),
    limiter_slope_friction_2d: UsePreconditionerCgEnumToJSON(value["limiterSlopeFriction2d"]),
    max_non_linear_newton_iterations: value["maxNonLinearNewtonIterations"],
    max_degree_gauss_seidel: value["maxDegreeGaussSeidel"],
    min_friction_velocity: value["minFrictionVelocity"],
    min_surface_area: value["minSurfaceArea"],
    use_preconditioner_cg: UsePreconditionerCgEnumToJSON(value["usePreconditionerCg"]),
    preissmann_slot: value["preissmannSlot"],
    limiter_slope_thin_water_layer: value["limiterSlopeThinWaterLayer"],
    use_of_cg: value["useOfCg"],
    use_nested_newton: value["useNestedNewton"],
    flooding_threshold: value["floodingThreshold"],
  };
}
